import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPanel.css";
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";
import { Spinner, Alert, Button, Card, Row, Col } from 'react-bootstrap';

const API_BASE_URL = "https://api.saadmotors.com/purchased_vehicles.php";

const PurchasedVehicles = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userId, setUserId] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [vehicles, setVehicles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const storedUserType = localStorage.getItem("usertype");
        const storedUserId = localStorage.getItem("userId");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lName");

        if (!storedUserType) {
            navigate("/login");
        } else {
            setUserType(storedUserType);
            setUserId(storedUserId);
            if (storedFName && storedLName) {
                setUserFullName(`${storedFName} ${storedLName}`);
            } else {
                setUserFullName(storedFName || '');
            }
        }

        if (storedUserId) {
            fetchVehicles(storedUserId);
        } else {
            setError("User ID not found in localStorage");
            setLoading(false);
        }
    }, [navigate]);

    const fetchVehicles = async (userId) => {
        try {
            setLoading(true);
            setError("");
            const response = await fetch(`${API_BASE_URL}?action=getPurchasedVehicles&clientId=${userId}`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const result = await response.json();
            console.log('API Response:', result); // Debug the response
            if (result.success) {
                setVehicles(result.data || []);
                if (result.data.length === 0) {
                    setError("No purchased vehicles found");
                }
            } else {
                setError(result.message || "Failed to fetch vehicles");
            }
        } catch (err) {
            setError("Failed to connect to the server. Please try again later.");
            console.error("Fetch vehicles error:", err);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return 'N/A';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const logout = () => {
        localStorage.clear();
        navigate("/login");
    };

    const getStatusCount = (status) => {
        return vehicles.filter(vehicle => vehicle.status === status).length;
    };

    const handleImageClick = (id) => {
        console.log('Attempting to navigate to images for stock ID:', id);
        navigate(`/purchased-images/${id}`);
    };

    const handleDocsClick = (id) => {
        console.log('Attempting to navigate to docs for stock ID:', id);
        navigate(`/view-purchase-docs/${id}`);
    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <AdministratorSidebar />}
                {userType === "admin" && <AdminSidebar />}
                {userType === "user" && <UserSidebar />}
            </div>

            <div className="admin-content">
                <div className="adminnavbar">
                    <h1 style={{ fontSize: '1.3rem', fontWeight: 'bold' }}>
                        Welcome to the Admin Panel, {userFullName}
                    </h1>
                    <button
                        onClick={logout}
                        style={{
                            backgroundColor: '#dc3545',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            padding: '4px 12px',
                            fontWeight: 'bold',
                            fontSize: '0.85rem',
                            cursor: 'pointer'
                        }}
                    >
                        Logout
                    </button>
                </div>

                <div className="mainsection">
                    <h3 style={{ fontSize: '1rem', fontWeight: 'bold', marginBottom: '1rem' }}>
                        Your Purchased Vehicles
                    </h3>

                    <div style={{ display: 'flex', gap: '8px', marginBottom: '1.2rem' }}>
                        <Button
                            style={{
                                backgroundColor: '#f8f9fa',
                                color: '#000',
                                border: '1px solid #dee2e6',
                                borderRadius: '5px',
                                padding: '4px 12px',
                                fontWeight: 'normal',
                                fontSize: '0.85rem'
                            }}
                        >
                            Not Shipped ({getStatusCount('Not Shipped')})
                        </Button>
                        <Button
                            style={{
                                backgroundColor: '#f8f9fa',
                                color: '#000',
                                border: '1px solid #dee2e6',
                                borderRadius: '5px',
                                padding: '4px 12px',
                                fontWeight: 'normal',
                                fontSize: '0.85rem'
                            }}
                        >
                            Planned ({getStatusCount('Planned')})
                        </Button>
                        <Button
                            style={{
                                backgroundColor: '#f8f9fa',
                                color: '#000',
                                border: '1px solid #dee2e6',
                                borderRadius: '5px',
                                padding: '4px 12px',
                                fontWeight: 'normal',
                                fontSize: '0.85rem'
                            }}
                        >
                            In Transit ({getStatusCount('In Transit')})
                        </Button>
                        <Button
                            style={{
                                backgroundColor: '#f8f9fa',
                                color: '#000',
                                border: '1px solid #dee2e6',
                                borderRadius: '5px',
                                padding: '4px 12px',
                                fontWeight: 'normal',
                                fontSize: '0.85rem'
                            }}
                        >
                            Arrived ({getStatusCount('Arrived')})
                        </Button>
                        <Button
                            style={{
                                backgroundColor: '#f8f9fa',
                                color: '#000',
                                border: '1px solid #dee2e6',
                                borderRadius: '5px',
                                padding: '4px 12px',
                                fontWeight: 'normal',
                                fontSize: '0.85rem'
                            }}
                        >
                            ALL ({vehicles.length})
                        </Button>
                    </div>

                    {error && (
                        <Alert variant="info" className="mt-3">
                            {error}
                            <Button
                                variant="primary"
                                size="sm"
                                className="ms-2"
                                onClick={() => fetchVehicles(userId)}
                            >
                                Retry
                            </Button>
                        </Alert>
                    )}

                    {loading ? (
                        <div className="text-center my-4">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                            <p style={{ fontSize: '0.85rem' }}>Loading your vehicles...</p>
                        </div>
                    ) : vehicles.length > 0 ? (
                        vehicles.map((vehicle, index) => (
                            <Card
                                key={index}
                                style={{
                                    marginBottom: '1.2rem',
                                    border: '1px solid #dee2e6',
                                    borderRadius: '8px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    overflow: 'hidden'
                                }}
                            >
                                <Card.Body>
                                    <Row>
                                        <Col
                                            md={2}
                                            style={{
                                                padding: '0.8rem',
                                                borderRight: '1px solid #dee2e6',
                                                textAlign: 'center'
                                            }}
                                        >
                                            <img
                                                src={vehicle.images ? `https://api.saadmotors.com/${vehicle.images}` : 'https://via.placeholder.com/150'}
                                                alt="Vehicle"
                                                style={{
                                                    width: '100%',
                                                    maxHeight: '120px',
                                                    objectFit: 'cover',
                                                    borderRadius: '5px',
                                                    marginBottom: '0.5rem',
                                                    cursor: 'pointer'
                                                }}
                                                onError={(e) => (e.target.src = 'https://via.placeholder.com/150')}
                                                onClick={() => {
                                                    console.log('Stock ID:', vehicle.stock_id);
                                                    handleImageClick(vehicle.stock_id);
                                                }}
                                            />
                                            <div>
                                                <Button
                                                    style={{
                                                        backgroundColor: '#ffc107',
                                                        color: '#000',
                                                        border: 'none',
                                                        borderRadius: '5px',
                                                        padding: '4px 12px',
                                                        marginRight: '5px',
                                                        fontWeight: 'bold',
                                                        fontSize: '0.75rem'
                                                    }}
                                                >
                                                    INVOICE
                                                </Button>
                                                <Button
                                                    style={{
                                                        backgroundColor: 'transparent',
                                                        color: '#007bff',
                                                        border: '1px solid #007bff',
                                                        borderRadius: '5px',
                                                        padding: '4px 12px',
                                                        fontWeight: 'bold',
                                                        fontSize: '0.75rem'
                                                    }}
                                                    onClick={() => handleDocsClick(vehicle.stock_id)}
                                                >
                                                    DOCS
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col
                                            md={3}
                                            style={{
                                                padding: '0.8rem',
                                                borderRight: '1px solid #dee2e6'
                                            }}
                                        >
                                            <h6
                                                style={{
                                                    fontWeight: 'bold',
                                                    fontSize: '0.9rem',
                                                    marginBottom: '0.5rem',
                                                    textAlign: 'center',
                                                    border: '1px solid #dee2e6',
                                                    padding: '0.3rem',
                                                    borderRadius: '5px'
                                                }}
                                            >
                                                Vehicle Details
                                            </h6>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem' }}>VIN:</strong>
                                                <span style={{ fontSize: '0.8rem' }}>{vehicle.vin || 'N/A'}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem' }}>Year:</strong>
                                                <span style={{ fontSize: '0.8rem' }}>{vehicle.year || 'N/A'}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem' }}>Stock ID:</strong>
                                                <span style={{ fontSize: '0.8rem' }}>{vehicle.stock_id || 'N/A'}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem' }}>Mileage:</strong>
                                                <span style={{ fontSize: '0.8rem' }}>{vehicle.mileage ? `${vehicle.mileage} km` : 'N/A'}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem' }}>Engine:</strong>
                                                <span style={{ fontSize: '0.8rem' }}>{vehicle.engine || 'N/A'}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem' }}>Purchase Date:</strong>
                                                <span style={{ fontSize: '0.8rem' }}>{formatDate(vehicle.purchase_date)}</span>
                                            </div>
                                        </Col>
                                        <Col
                                            md={3}
                                            style={{
                                                padding: '0.8rem',
                                                borderRight: '1px solid #dee2e6'
                                            }}
                                        >
                                            <h6
                                                style={{
                                                    fontWeight: 'bold',
                                                    fontSize: '0.9rem',
                                                    marginBottom: '0.5rem',
                                                    textAlign: 'center',
                                                    border: '1px solid #dee2e6',
                                                    padding: '0.3rem',
                                                    borderRadius: '5px'
                                                }}
                                            >
                                                Finance Details
                                            </h6>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem' }}>Sold Price:</strong>
                                                <span style={{ fontSize: '0.8rem' }}>${parseFloat(vehicle.sold_price || 0).toLocaleString()}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem' }}>Allocated:</strong>
                                                <span style={{ fontSize: '0.8rem' }}>${parseFloat(vehicle.allocated_amount || 0).toLocaleString()}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem' }}>A.S. Net:</strong>
                                                <span style={{ fontSize: '0.8rem' }}>N/A</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem', color: '#dc3545' }}>Total:</strong>
                                                <span
                                                    style={{
                                                        fontSize: '0.8rem',
                                                        backgroundColor: '#ffc107',
                                                        padding: '2px 6px',
                                                        borderRadius: '3px'
                                                    }}
                                                >
                                                    ${parseFloat(vehicle.sold_price || 0).toLocaleString()}
                                                </span>
                                            </div>
                                        </Col>
                                        <Col
                                            md={4}
                                            style={{
                                                padding: '0.8rem'
                                            }}
                                        >
                                            <h6
                                                style={{
                                                    fontWeight: 'bold',
                                                    fontSize: '0.9rem',
                                                    marginBottom: '0.5rem',
                                                    textAlign: 'center',
                                                    border: '1px solid #dee2e6',
                                                    padding: '0.3rem',
                                                    borderRadius: '5px'
                                                }}
                                            >
                                                Shipment Details
                                            </h6>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem' }}>Vessel Name:</strong>
                                                <span style={{ fontSize: '0.8rem' }}>{vehicle.vessel_name || 'N/A'}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem' }}>Shipping Line:</strong>
                                                <span style={{ fontSize: '0.8rem' }}>{vehicle.shipping_line || 'N/A'}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem' }}>ETD:</strong>
                                                <span style={{ fontSize: '0.8rem' }}>{formatDate(vehicle.etd)}</span>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0.2rem 0' }}>
                                                <strong style={{ fontSize: '0.8rem' }}>ETA:</strong>
                                                <span style={{ fontSize: '0.8rem' }}>{formatDate(vehicle.eta)}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        ))
                    ) : (
                        <div className="text-center mt-4">
                            <p style={{ fontSize: '0.85rem' }}>No vehicles found.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PurchasedVehicles;